import { render } from "./tijiao.vue?vue&type=template&id=e080d15a&scoped=true"
import script from "./tijiao.vue?vue&type=script&lang=js"
export * from "./tijiao.vue?vue&type=script&lang=js"

import "./tijiao.vue?vue&type=style&index=0&id=e080d15a&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e080d15a"]])

export default __exports__